<ngx-spinner></ngx-spinner>
<router-outlet></router-outlet>